// removed by extract-text-webpack-plugin
module.exports = {"container":"_1UlSEXLr0 _17qxy1jyE _1IPt6zvnw OZwVRouuZ _30W7J4cYZ","header":"_2-fCv1CUt _2fVz2KYnB _3lHRe10pm tyCNynHr-","content":"_3qrKht2Hj _17qxy1jyE _19xNUQLWh","autosize-container":"_3b1HBRMfy _19xNUQLWh","loading":"_1QLhun1Rq _17qxy1jyE qigzzAbil _2l0xl0HVf _1-iZsM4yd _3EiT4eWlg _2OB3nmlqn"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/event-group-grid-page/event-group-grid-page.css
 ** module id = 2187
 ** module chunks = 0
 **/